import { lensPath, set } from 'ramda';
import { cfgOptionsPaths } from '../constants/cfgOptionsPaths';
/**
 * Утилита парсит плоский конфиг для графика chart.js, переданный в пропсе chartCfgParams
 * @example
  const flatConfig = { xAfterTickToLabelConversion: function(){} }
  const parsedConfig = parseChartFlatConfig(flatConfig)

 * Результат:
 * {
 *   options: { scales: {x: afterTickToLabelConversion: function(){} } }
 * }
 * */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var parseChartFlatConfig = function parseChartFlatConfig(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    var cfgPath = cfgOptionsPaths[key];
    if (cfgPath) {
      var lens = lensPath(cfgPath.split('.'));
      return set(lens, obj[key], acc);
    }
    return acc;
  }, {});
};